const file = {};
let fileElement;

const createFileElement = () => {
  fileElement = document.createElement('a');
  document.body.appendChild(fileElement);
};

const removeFileElement = () => {
  document.body.removeChild(fileElement);
};

file.download = (data, type, name) => {
  createFileElement();
  fileElement.href = window.URL.createObjectURL(new Blob([data], { type }));
  fileElement.download = name;
  fileElement.click();

  removeFileElement();
};

export default file;



// WEBPACK FOOTER //
// ./src/helpers/file.js